import { useContext } from 'react';
import { FileContext } from '../context/FileContext';

export function usePreviewFlow() {
  const { previewFlowData, setPreviewFlowData, documentRef } =
    useContext(FileContext);

  const activeFile = previewFlowData?.activeFile?.file;
  const activeFileId = previewFlowData?.activeFileId;
  const activeFields = previewFlowData?.attachedFiles?.find(
    (file) => file._id === activeFileId,
  )?.fields;

  const attachedFiles = previewFlowData?.attachedFiles;

  const updatePreviewFlowData = (key, val) => {
    setPreviewFlowData((prev) => {
      return {
        ...prev,
        [key]: val,
      };
    });
  };

  const updateAttachedFiles = (val) => {
    updatePreviewFlowData('attachedFiles', val);
    updateActiveFileId(val[0]._id);
  };

  const updateActiveFileId = (val) => {
    updatePreviewFlowData('activeFileId', val);
  };

  const updateActiveFile = (val) => {
    updatePreviewFlowData('activeFile', val);
  };

  const scrollToTop = () => {
    documentRef.current?.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  return {
    activeFile,
    activeFileId,
    activeFields,
    attachedFiles,
    scrollToTop,
    updateActiveFile,
    updateActiveFileId,
    updateAttachedFiles,
  };
}
